import React from "react";
import queImage from "src/assets/i_que.svg";
import eventBus from "src/utils/eventBus";

interface TableLabelProp {
    name: string;
    date?: string;
    modalData?: {
        title: string;
        content: string[];
    };
}

const TableLabel: React.FC<TableLabelProp> = ({ name, date, modalData }) => {
    const handleOpenModal = ( modalData ) => {
        eventBus.emit("explainModal:show", { message: modalData });
    };

    return (
        <div className="d-flex align-items-center gap-1">
            <h2 className="fw-semibold">{name}</h2>
                {modalData && (
                    <button type="button" onClick={() => handleOpenModal(modalData)}>
                        <img src={queImage} alt="" />
                    </button>
                    )}
            {date && <small className="text-black2">{date}</small>}
        </div>
    );
};
export default TableLabel;
